import { render, staticRenderFns } from "./ArticleComment.vue?vue&type=template&id=5c09dcb7&"
import script from "./ArticleComment.vue?vue&type=script&lang=js&"
export * from "./ArticleComment.vue?vue&type=script&lang=js&"
import style0 from "./ArticleComment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
